import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {
    AuthenticationService,
    CookieService,
    CookieUtil,
    Platform,
    CommonPlatformService,
    SelectUserDTO,
    CommonUserService,
    CommonUtil
} from 'psd-common';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'central-login-join',
    templateUrl: 'central-login-join.component.html'
})
export class CentralLoginJoinComponent implements OnInit {
    public submitting: boolean = false;
    public submitted: boolean = false;
    public userJoined: boolean = false;
    public joinError: boolean = false;
    public platformPrefix: string;
    public userEmail: string;
    public joinToken: string;
    public centralAccessToken: string;
    public centralRefreshToken: string;
    public accessToken: string;
    public refreshToken: string;
    public expiresIn: string;
    public platformUrl: string;
    public joinForm: FormGroup;
    public currentPlatform: Platform;
    public userAccountInactive: boolean = false;
    public activationMailSent: boolean = false;
    public emailErrorMessage: string;
    public emailStatus: string;
    public badCredentials: boolean = false;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private platformService: CommonPlatformService,
        private authenticationService: AuthenticationService,
        private cookieService: CookieService,
        private userService: CommonUserService,
        private router: Router
    ) {}

    ngOnInit() {
        // todo: check if user is already logged in, if so => do join automatically
        this.renderer.addClass(this.document.body, 'login');
        this.route.queryParams.subscribe(_params => {
            this.platformPrefix = _params.platform;
            this.userEmail = _params.email;
            this.emailStatus = _params.emailStatus;
            this.joinToken = _params.joinToken;
            if (this.platformPrefix) {
                this.platformService.getExternalPlatformDetails(this.platformPrefix).subscribe(_platform => {
                    this.currentPlatform = _platform;
                });
            }

            if(this.emailStatus == 'NOT_ACTIVE') {
                this.userAccountInactive = true;
                this.emailErrorMessage = 'central-login.failure.email.error.not.active';
            }

            if(this.emailStatus == 'SSO') {
                this.authenticationService.checkEmail(this.userEmail, this.platformPrefix).subscribe(_result => {
                    if(_result.redirectUrl) {
                        window.location.href = _result.redirectUrl + '?joinToken=' + this.joinToken + '&email=' + this.userEmail;
                    }
                });
            }

        });

        this.joinForm = this.formBuilder.group(
            {
                password: ['', [Validators.required]]
            },
            {}
        );
    }

    ngAfterViewInit() {
        if (!this.userAccountInactive) {
            setTimeout(() => {
                document.getElementById('password').focus();
            }, 100);
        }
    }

    get form() {
        return this.joinForm.controls;
    }

    join() {
        this.submitted = true;
        this.badCredentials = false;

        // stop here if form is invalid
        if (this.joinForm.invalid) {
            return;
        }

        this.submitting = true;
        let json = JSON.parse(JSON.stringify(this.joinForm.value, null, 4));

        this.authenticationService.login('login', this.userEmail, json.password, this.platformPrefix != null ? this.platformPrefix : null).subscribe(_result => {
            this.centralAccessToken = _result.access_token;
            this.centralRefreshToken = _result.refresh_token;

            CookieUtil.setCentralCookies(this.centralAccessToken, this.centralRefreshToken, environment.production, _result.expires_in)

            localStorage.setItem('userEmail', json.email);

            let platformURL = CommonUtil.getBaseURL(this.currentPlatform.name, 'api', environment.production, this.currentPlatform.domainExtension);

            this.userService.joinPlatform(this.joinToken, this.userEmail, platformURL, this.centralAccessToken).subscribe(
                _joinResult => {
                    this.userJoined = true;
                    let selectUserDTO: SelectUserDTO = new SelectUserDTO();
                    selectUserDTO.platformId = this.currentPlatform.id;
                    selectUserDTO.userId = _joinResult.id;

                    this.authenticationService.selectUser(selectUserDTO, this.centralAccessToken, platformURL).subscribe(
                        _selectUserResult => {
                            let me = this;
                            this.accessToken = _selectUserResult.access_token;
                            this.refreshToken = _selectUserResult.refresh_token;
                            this.expiresIn = _selectUserResult.expires_in;
                            setTimeout(function() {
                                me.goToPlatform();
                            }, 5000);
                        },
                        _selectUserError => {
                            this.joinError = true;
                            this.submitting = false;
                            localStorage.removeItem('userEmail');
                            this.cookieService.deleteCentralCookie('central_access_token', environment.production);
                            this.cookieService.deleteCentralCookie('central_refresh_token', environment.production);
                        }
                    );
                },
                _error => {
                    // todo: show more specific error => error when join token is not available anymore...
                    this.joinError = true;
                    this.submitting = false;
                    localStorage.removeItem('userEmail');
                    this.cookieService.deleteCentralCookie('central_access_token', environment.production);
                    this.cookieService.deleteCentralCookie('central_refresh_token', environment.production);
                }
            );
        },
            _error => {
                this.emailErrorMessage = 'central-login.join.error';
                this.badCredentials = true;
                this.submitting = false;
            });
    }

    goToLogin() {
        this.router.navigate(['/central-login/login'], { queryParams: { platform: this.platformPrefix }});
    }

    goToPlatform() {
        // @ts-ignore
        let platformForm: HTMLFormElement = document.getElementById('goToPlatformForm');
        platformForm.action = CommonUtil.getBaseURL(this.platformPrefix, 'platform', environment.production, this.currentPlatform.domainExtension) + '/index.php';
        platformForm['central_access_token'].value = this.centralAccessToken;
        platformForm['central_refresh_token'].value = this.centralRefreshToken;
        platformForm['access_token'].value = this.accessToken;
        platformForm['refresh_token'].value = this.refreshToken;
        platformForm['expires_in'].value = this.expiresIn;
        platformForm['force_token_refresh'].value = 'true';
        platformForm.submit();
    }
}
